module.exports = __webpack_public_path__ + "static/media/image (22).a5014fb7.jpg";